var React = require('react');

function Added (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9","cy":"9","r":"8","stroke":"currentColor","strokeWidth":"2","fill":"transparent","key":0}),React.createElement("path",{"d":"M9.21559 13.0596L12.4033 9.86325C12.5322 9.73437 12.5322 9.51956 12.4033 9.39068L11.6214 8.60877C11.4926 8.47989 11.2777 8.47989 11.1489 8.60877L9.8686 9.88903V5.3351C9.8686 5.14607 9.71394 5 9.5335 5H8.42509C8.23606 5 8.08999 5.15466 8.08999 5.3351V9.88903L6.80114 8.60018C6.67226 8.4713 6.45745 8.4713 6.32856 8.60018L5.54666 9.38208C5.41778 9.51097 5.41778 9.72578 5.54666 9.85466L8.73442 13.0424C8.87189 13.1885 9.07811 13.1885 9.21559 13.0596Z","fill":"currentColor","key":1})]);
}

Added.defaultProps = {"viewBox":"0 0 18 18","fill":"none","style":{"color":"#39424A"}};

module.exports = Added;

Added.default = Added;
